export const getCoordinates = (data) => {
    const getBalloon = () => void 0;
    if (Array.isArray(data)) {
        return data
            .map((_) => ({
            coords: [Number(_.gpsLatitude), Number(_.gpsLongitude)].filter(Boolean),
            content: getBalloon(),
        }))
            .filter((_) => _.coords && _.coords.length === 2);
    }
    if (data?.gpsLatitude && data?.gpsLongitude) {
        return [{ coords: [data.gpsLatitude, data.gpsLongitude] }];
    }
    return [];
};
export const getBranch = (branches, selectedBranch) => branches.find((_) => _.branchCode === selectedBranch);
//# sourceMappingURL=utils.js.map